// extracted by mini-css-extract-plugin
module.exports = {"title":"_86bd3","wrapper":"_63228","header":"_42540"};